var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFedex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#4F1090"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1453 18.5236L32.4689 20.0116L33.7431 18.5236H36.4641L33.8049 21.5739L36.5005 24.6491H33.6698L32.3587 23.1494L31.0595 24.6491H28.3262L30.9982 21.5866L28.3262 18.5236H31.1453Z",
    fill: "#FF5900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3265 18.5236V20.5932H25.3002V22.4924H28.3265V24.6491H23.0762V15H28.3265V17.1508H25.3002V18.5236H28.3265Z",
    fill: "#FF5900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8607 15V18.9489H20.8362C20.3456 18.374 19.7331 18.174 19.0224 18.174C17.5664 18.174 16.4695 19.1842 16.0846 20.5189C15.645 19.0481 14.5126 18.1464 12.8334 18.1464C11.4699 18.1464 10.393 18.7707 9.83119 19.788V18.5236H7.01248V17.1508H10.0885V15H4.5V24.6491H7.01248V20.5932H9.51696C9.44229 20.8911 9.40229 21.2103 9.40229 21.5471C9.40229 23.5596 10.9099 24.9723 12.8334 24.9723C14.4513 24.9723 15.5175 24.1975 16.081 22.7853H13.9277C13.6366 23.2101 13.4157 23.3357 12.8334 23.3357C12.1583 23.3357 11.5761 22.735 11.5761 22.0227H15.9606C16.1508 23.6213 17.3717 25 19.0469 25C19.7695 25 20.4313 24.6373 20.8358 24.0253H20.8602V24.65H23.0749V15H20.8607ZM11.6463 20.6218C11.7859 20.0088 12.2521 19.6085 12.8339 19.6085C13.4743 19.6085 13.9166 19.9966 14.033 20.6218H11.6463ZM18.1922 21.5938C18.1922 22.404 18.6998 23.1802 19.5162 23.1802C20.4096 23.1802 20.7958 22.4149 20.7958 21.5938C20.7958 20.7279 20.4313 19.895 19.5162 19.895C18.6335 19.895 18.1922 20.7279 18.1922 21.5938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFedex);
export default __webpack_public_path__ + "static/media/fedex.0401aac2059f047e5c48ed0b259c345b.svg";
export { ForwardRef as ReactComponent };